import React from 'react';
import { metricKeys } from '@pulse/metrics';
import { humanize } from '@utils';
import { getMetricMetaByKey, getMetricUnit } from '@src/utils/metrics';
import ViewerIdCell from './ViewerIdCell';

export const viewerSessionMetricList = [
  metricKeys.StreamingPerformanceIndex,
  metricKeys.BadSession,
  metricKeys.HighRebuffering,
  metricKeys.HighStartupTime,
  metricKeys.LowBitrate,
  metricKeys.VideoPlaybackFailuresTech,
  metricKeys.VideoStartFailuresTech,
  metricKeys.HighExitBeforeVideoStart,
];

const formatMetricData = ({ column, rowData }) => {
  const { dataKey } = column;
  const rawValue = rowData[dataKey];

  // mask low values
  if (rawValue === 'low') {
    return rawValue;
  }

  const unit = getMetricUnit({ metricKey: dataKey });
  const value = humanize(rowData[dataKey], unit);
  return unit !== '' ? `${value} ${unit}` : value;
};

const getMetricTitle = (metricKey) => {
  const metricInfo = getMetricMetaByKey({ metricKey });
  if (metricKey === metricKeys.StreamingPerformanceIndex) {
    return metricInfo.short;
  }
  return metricInfo.ovbDisplayName || metricInfo.displayName;
};

function buildColumns() {
  const viewerIdColumn: any = {
    title: 'Viewer ID',
    key: 'VIEWER_ID',
    dataKey: 'VIEWER_ID',
    width: 300,
    align: 'left',
    frozen: true,
    resizable: true,
    cellRenderer: ({ rowData }) => <ViewerIdCell rowData={rowData} />,
  };

  const metricColumns = viewerSessionMetricList.map((metric) => ({
    title: getMetricTitle(metric),
    key: metric,
    dataKey: metric,
    width: 120,
    align: 'left',
    dataGetter: formatMetricData,
    sortable: metric !== metricKeys.StreamingPerformanceIndex,
  }));

  return [viewerIdColumn, ...metricColumns];
}

export { buildColumns };
